export const footerLinks = {
    'us-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    title: 'Las Vegas',
                    href: 'https://www.wingie.com/flights/to-las-vegas/',
                },
                {
                    title: 'Chicago',
                    href: 'https://www.wingie.com/flights/to-chicago/',
                },
                {
                    title: 'Miami',
                    href: 'https://www.wingie.com/flights/to-miami/',
                },
                {
                    title: 'Cancun',
                    href: 'https://www.wingie.com/flights/to-cancun/',
                },
                {
                    title: 'London',
                    href: 'https://www.wingie.com/flights/to-london/',
                },
                {
                    title: 'Honolulu',
                    href: 'https://www.wingie.com/flights/to-honolulu/',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    title: 'Canada',
                    href: 'https://www.wingie.com/flights/ca-canada/',
                },
                {
                    title: 'China',
                    href: 'https://www.wingie.com/flights/cn-china/',
                },
                {
                    title: 'Costa Rica',
                    href: 'https://www.wingie.com/flights/cr-costa-rica/',
                },
                {
                    title: 'Dominican Republic',
                    href: 'https://www.wingie.com/flights/do-dominican-republic/',
                },
                {
                    title: 'El Salvador',
                    href: 'https://www.wingie.com/flights/sv-el-salvador/',
                },
                {
                    title: 'France',
                    href: 'https://www.wingie.com/flights/fr-france/',
                },
            ],
        },
        {
            title: 'Popular Airlines',

            items: [
                {
                    title: 'American Airlines',
                    href: 'https://www.wingie.com/flights/airlines/american-airlines/',
                },
                {
                    title: 'Delta Air lines',
                    href: 'https://www.wingie.com/flights/airlines/delta-air-lines/',
                },
                {
                    title: 'United Airlines',
                    href: 'https://www.wingie.com/flights/airlines/united-airlines/',
                },
                {
                    title: 'Alaska Airlines',
                    href: 'https://www.wingie.com/flights/airlines/alaska-airlines/',
                },
                {
                    title: 'JetBlue',
                    href: 'https://www.wingie.com/flights/airlines/jetblue/',
                },
                {
                    title: 'Hawaiian Airlines',
                    href: 'https://www.wingie.com/flights/airlines/hawaiian-airlines/',
                },
            ],
        },
    ],
    'us-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    title: 'Las Vegas',
                    href: 'https://www.wingie.com/es/vuelos/a-las-vegas/',
                },
                {
                    title: 'Chicago',
                    href: 'https://www.wingie.com/es/vuelos/a-chicago/',
                },
                {
                    title: 'Miami',
                    href: 'https://www.wingie.com/es/vuelos/a-miami/',
                },
                {
                    title: 'Cancun',
                    href: 'https://www.wingie.com/es/vuelos/a-cancun/',
                },
                {
                    title: 'London',
                    href: 'https://www.wingie.com/es/vuelos/a-london/',
                },
                {
                    title: 'Honolulu',
                    href: 'https://www.wingie.com/es/vuelos/a-honolulu/',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    title: 'Canadá',
                    href: 'https://www.wingie.com/es/vuelos/ca-canada/',
                },
                {
                    title: 'China',
                    href: 'https://www.wingie.com/es/vuelos/cn-china/',
                },
                {
                    title: 'Costa Rica',
                    href: 'https://www.wingie.com/es/vuelos/cr-costa-rica/',
                },
                {
                    title: 'República Dominicana',
                    href: 'https://www.wingie.com/es/vuelos/do-dominican-republic/',
                },
                {
                    title: 'El Salvador',
                    href: 'https://www.wingie.com/es/vuelos/sv-el-salvador/',
                },
                {
                    title: 'Francia',
                    href: 'https://www.wingie.com/es/vuelos/fr-france/',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    title: 'American Airlines',
                    href: 'https://www.wingie.com/es/vuelos/companias-aereas/american-airlines/',
                },
                {
                    title: 'Delta Air lines',
                    href: 'https://www.wingie.com/es/vuelos/companias-aereas/delta-air-lines/',
                },
                {
                    title: 'United Airlines',
                    href: 'https://www.wingie.com/es/vuelos/companias-aereas/united-airlines/',
                },
                {
                    title: 'Alaska Airlines',
                    href: 'https://www.wingie.com/es/vuelos/companias-aereas/alaska-airlines/',
                },
                {
                    title: 'JetBlue',
                    href: 'https://www.wingie.com/es/vuelos/companias-aereas/jetblue/',
                },
                {
                    title: 'Hawaiian Airlines',
                    href: 'https://www.wingie.com/es/vuelos/companias-aereas/hawaiian-airlines/',
                },
            ],
        },
    ],
    'us-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://www.wingie.com/de/flug/nach-las-vegas/',
                    title: 'Las Vegas',
                },
                {
                    href: 'https://www.wingie.com/de/flug/nach-chicago/',
                    title: 'Chicago',
                },
                {
                    href: 'https://www.wingie.com/de/flug/nach-miami/',
                    title: 'Miami',
                },
                {
                    href: 'https://www.wingie.com/de/flug/nach-cancun/',
                    title: 'Cancún',
                },
                {
                    href: 'https://www.wingie.com/de/flug/nach-london/',
                    title: 'London',
                },
                {
                    href: 'https://www.wingie.com/de/flug/nach-honolulu/',
                    title: 'Honolulu',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://www.wingie.com/de/flug/ca-kanada/',
                    title: 'Kanada',
                },
                {
                    href: 'https://www.wingie.com/de/flug/cn-china/',
                    title: 'China',
                },
                {
                    href: 'https://www.wingie.com/de/flug/cr-costa-rica/',
                    title: 'Costa Rica',
                },
                {
                    href: 'https://www.wingie.com/de/flug/do-dominikanische-republik/',
                    title: 'Dominikanische Republik',
                },
                {
                    href: 'https://www.wingie.com/de/flug/sv-el-salvador/',
                    title: 'El Salvador',
                },
                {
                    href: 'https://www.wingie.com/de/flug/fr-frankreich/',
                    title: 'Frankreich',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://www.wingie.com/de/flug/airlines/american-airlines/',
                    title: 'American Airlines',
                },
                {
                    href: 'https://www.wingie.com/de/flug/airlines/delta-air-lines/',
                    title: 'Delta Air Lines',
                },
                {
                    href: 'https://www.wingie.com/de/flug/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://www.wingie.com/de/flug/airlines/alaska-airlines/',
                    title: 'Alaska Airlines',
                },
                {
                    href: 'https://www.wingie.com/de/flug/airlines/jetblue/',
                    title: 'JetBlue',
                },
                {
                    href: 'https://www.wingie.com/de/flug/airlines/hawaiian-airlines/',
                    title: 'Hawaiian Airlines',
                },
            ],
        },
    ],
    'us-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://www.wingie.com/ru/flights/to-las-vegas/',
                    title: 'Лас-Вегас',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/to-chicago/',
                    title: 'Чикаго',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/to-miami/',
                    title: 'Майами',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/to-cancun/',
                    title: 'Канкун',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/to-london/',
                    title: 'Лондон',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/to-honolulu/',
                    title: 'Гонолулу',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://www.wingie.com/ru/flights/ca-canada/',
                    title: 'Канада',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/cn-china/',
                    title: 'Китай',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/cr-costa-rica/',
                    title: 'Коста-Рика',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/do-dominican-republic/',
                    title: 'Доминиканская Республика',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/sv-el-salvador/',
                    title: 'Эль Сальвадор',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/fr-france/',
                    title: 'Франция',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://www.wingie.com/ru/flights/airlines/american-airlines/',
                    title: 'American Airlines',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/airlines/delta-air-lines/',
                    title: 'Delta Air Lines',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/airlines/united-airlines/',
                    title: 'United Airlines',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/airlines/alaska-airlines/',
                    title: 'Alaska Airlines',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/airlines/jetblue/',
                    title: 'JetBlue',
                },
                {
                    href: 'https://www.wingie.com/ru/flights/airlines/hawaiian-airlines/',
                    title: 'Hawaiian Airlines',
                },
            ],
        },
    ],
    'us-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://www.wingie.com/ar/flights/to-las-vegas/',
                    title: 'لاس فيغاس',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/to-chicago/',
                    title: 'شيكاغو',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/to-miami/',
                    title: 'ميامي',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/to-cancun/',
                    title: 'كانكون',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/to-london/',
                    title: 'لندن',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/to-honolulu/',
                    title: 'هونولولو',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://www.wingie.com/ar/flights/ca-canada/',
                    title: 'كندا',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/cn-china/',
                    title: 'الصين',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/cr-costa-rica/',
                    title: 'كوستاريكا',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/do-dominican-republic/',
                    title: 'جمهورية الدومينيكان',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/sv-el-salvador/',
                    title: 'السلفادور',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/fr-france/',
                    title: 'فرنسا',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://www.wingie.com/ar/flights/airlines/american-airlines/',
                    title: 'الخطوط الجوية الأمريكية\n',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/airlines/delta-air-lines/',
                    title: 'Delta Air Lines',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/airlines/united-airlines/',
                    title: 'الخطوط الجوية المتحدة\n',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/airlines/alaska-airlines/',
                    title: 'Alaska Airlines',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/airlines/jetblue/',
                    title: 'جت بلو ايرلاينز',
                },
                {
                    href: 'https://www.wingie.com/ar/flights/airlines/hawaiian-airlines/',
                    title: 'Hawaiian Airlines',
                },
            ],
        },
    ],
    'us-it': [
        {
            title: 'Principali destinazioni',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.com/it/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.com/it/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.com/it/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.com/it/flights/to-cancun/' },
                { title: 'Londra', href: 'https://www.wingie.com/it/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.com/it/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Paesi popolari',
            items: [
                { title: 'Canada', href: 'https://www.wingie.com/it/flights/ca-canada/' },
                { title: 'Cina', href: 'https://www.wingie.com/it/flights/cn-china/' },
                { title: 'Costa Rica', href: 'https://www.wingie.com/it/flights/cr-costa-rica/' },
                { title: 'Repubblica Dominicana', href: 'https://www.wingie.com/it/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.com/it/flights/sv-el-salvador/' },
                { title: 'Francia', href: 'https://www.wingie.com/it/flights/fr-france/' },
            ],
        },
        {
            title: 'Compagnie aeree popolari',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/it/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/it/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/it/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/it/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/it/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/it/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-fr': [
        {
            title: 'Principales destinations',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.com/fr/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.com/fr/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.com/fr/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.com/fr/flights/to-cancun/' },
                { title: 'Londres', href: 'https://www.wingie.com/fr/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.com/fr/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Pays populaires',
            items: [
                { title: 'Canada', href: 'https://www.wingie.com/fr/flights/ca-canada/' },
                { title: 'Chine', href: 'https://www.wingie.com/fr/flights/cn-china/' },
                { title: 'Costa Rica', href: 'https://www.wingie.com/fr/flights/cr-costa-rica/' },
                { title: 'République dominicaine', href: 'https://www.wingie.com/fr/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.com/fr/flights/sv-el-salvador/' },
                { title: 'France', href: 'https://www.wingie.com/fr/flights/fr-france/' },
            ],
        },
        {
            title: 'Compagnies aériennes populaires',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/fr/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/fr/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/fr/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/fr/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/fr/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/fr/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-pt': [
        {
            title: 'Principais destinos',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.com/pt/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.com/pt/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.com/pt/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.com/pt/flights/to-cancun/' },
                { title: 'Londres', href: 'https://www.wingie.com/pt/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.com/pt/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Países populares',
            items: [
                { title: 'Canadá', href: 'https://www.wingie.com/pt/flights/ca-canada/' },
                { title: 'China', href: 'https://www.wingie.com/pt/flights/cn-china/' },
                { title: 'Costa Rica', href: 'https://www.wingie.com/pt/flights/cr-costa-rica/' },
                { title: 'República Dominicana', href: 'https://www.wingie.com/pt/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.com/pt/flights/sv-el-salvador/' },
                { title: 'França', href: 'https://www.wingie.com/pt/flights/fr-france/' },
            ],
        },
        {
            title: 'Companhias aéreas populares',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/pt/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/pt/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/pt/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/pt/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/pt/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/pt/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-ro': [
        {
            title: 'Top destinații',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.com/ro/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.com/ro/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.com/ro/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.com/ro/flights/to-cancun/' },
                { title: 'Londra', href: 'https://www.wingie.com/ro/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.com/ro/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Țări populare',
            items: [
                { title: 'Canada', href: 'https://www.wingie.com/ro/flights/ca-canada/' },
                { title: 'China', href: 'https://www.wingie.com/ro/flights/cn-china/' },
                { title: 'Costa Rica', href: 'https://www.wingie.com/ro/flights/cr-costa-rica/' },
                { title: 'Republica Dominicană', href: 'https://www.wingie.com/ro/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.com/ro/flights/sv-el-salvador/' },
                { title: 'Franța', href: 'https://www.wingie.com/ro/flights/fr-france/' },
            ],
        },
        {
            title: 'Companii aeriene populare',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/ro/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/ro/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/ro/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/ro/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/ro/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/ro/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-pl': [
        {
            title: 'Najpopularniejsze kierunki',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.com/pl/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.com/pl/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.com/pl/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.com/pl/flights/to-cancun/' },
                { title: 'Londyn', href: 'https://www.wingie.com/pl/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.com/pl/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Popularne kraje',
            items: [
                { title: 'Kanada', href: 'https://www.wingie.com/pl/flights/ca-canada/' },
                { title: 'Chiny', href: 'https://www.wingie.com/pl/flights/cn-china/' },
                { title: 'Kostaryka', href: 'https://www.wingie.com/pl/flights/cr-costa-rica/' },
                { title: 'Dominikana', href: 'https://www.wingie.com/pl/flights/do-dominican-republic/' },
                { title: 'Salwador', href: 'https://www.wingie.com/pl/flights/sv-el-salvador/' },
                { title: 'Francja', href: 'https://www.wingie.com/pl/flights/fr-france/' },
            ],
        },
        {
            title: 'Popularne linie lotnicze',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/pl/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/pl/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/pl/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/pl/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/pl/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/pl/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-lt': [
        {
            title: 'Populiariausi maršrutai',
            items: [
                { title: 'Las Vegasas', href: 'https://www.wingie.com/lt/flights/to-las-vegas/' },
                { title: 'Čikaga', href: 'https://www.wingie.com/lt/flights/to-chicago/' },
                { title: 'Majamis', href: 'https://www.wingie.com/lt/flights/to-miami/' },
                { title: 'Kankūnas', href: 'https://www.wingie.com/lt/flights/to-cancun/' },
                { title: 'Londonas', href: 'https://www.wingie.com/lt/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.com/lt/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Populiarios šalys',
            items: [
                { title: 'Kanada', href: 'https://www.wingie.com/lt/flights/ca-kanada/' },
                { title: 'Kinija', href: 'https://www.wingie.com/lt/flights/cn-kinija/' },
                { title: 'Kosta Rika', href: 'https://www.wingie.com/lt/flights/cr-kosta-rika/' },
                { title: 'Dominikos Respublika', href: 'https://www.wingie.com/lt/flights/do-dominican-republic/' },
                { title: 'Salvadoras', href: 'https://www.wingie.com/lt/flights/sv-el-salvador/' },
                { title: 'Prancūzija', href: 'https://www.wingie.com/lt/flights/fr-prancuzija/' },
            ],
        },
        {
            title: 'Populiarios oro linijos',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/lt/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/lt/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/lt/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/lt/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/lt/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/lt/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-uz': [
        {
            title: "Mashhur yo'nalishlar",
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.com/uz/flights/to-las-vegas/' },
                { title: 'Chikago', href: 'https://www.wingie.com/uz/flights/to-chicago/' },
                { title: 'Mayami', href: 'https://www.wingie.com/uz/flights/to-miami/' },
                { title: 'Kankun', href: 'https://www.wingie.com/uz/flights/to-cancun/' },
                { title: 'London', href: 'https://www.wingie.com/uz/flights/to-london/' },
                { title: 'Gonolulu', href: 'https://www.wingie.com/uz/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Mashhur mamlakatlar',
            items: [
                { title: 'Kanada', href: 'https://www.wingie.com/uz/flights/ca-kanada/' },
                { title: 'Xitoy', href: 'https://www.wingie.com/uz/flights/cn-xitoy/' },
                { title: 'Kosta-Rika', href: 'https://www.wingie.com/uz/flights/cr-kosta-rika/' },
                { title: 'Dominikan Respublikasi', href: 'https://www.wingie.com/uz/flights/do-dominican-republic/' },
                { title: 'Salvador', href: 'https://www.wingie.com/uz/flights/sv-el-salvador/' },
                { title: 'Fransiya', href: 'https://www.wingie.com/uz/flights/fr-fransiya/' },
            ],
        },
        {
            title: 'Mashhur aviakompaniyalar',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/uz/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/uz/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/uz/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/uz/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/uz/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/uz/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-sr': [
        {
            title: 'Najpopularniji pravci',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.com/sr/flights/to-las-vegas/' },
                { title: 'Čikago', href: 'https://www.wingie.com/sr/flights/to-chicago/' },
                { title: 'Majami', href: 'https://www.wingie.com/sr/flights/to-miami/' },
                { title: 'Kankun', href: 'https://www.wingie.com/sr/flights/to-cancun/' },
                { title: 'London', href: 'https://www.wingie.com/sr/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.com/sr/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Popularne zemlje',
            items: [
                { title: 'Kanada', href: 'https://www.wingie.com/sr/flights/ca-kanada/' },
                { title: 'Kina', href: 'https://www.wingie.com/sr/flights/cn-kina/' },
                { title: 'Kostarika', href: 'https://www.wingie.com/sr/flights/cr-kostarika/' },
                { title: 'Dominikanska Republika', href: 'https://www.wingie.com/sr/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.com/sr/flights/sv-el-salvador/' },
                { title: 'Francuska', href: 'https://www.wingie.com/sr/flights/fr-francuska/' },
            ],
        },
        {
            title: 'Popularne avio-kompanije',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/sr/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/sr/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/sr/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/sr/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/sr/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/sr/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-ky': [
        {
            title: 'Эң популярдуу багыттар',
            items: [
                { title: 'Лас Вегас', href: 'https://www.wingie.com/ky/flights/to-las-vegas/' },
                { title: 'Чикаго', href: 'https://www.wingie.com/ky/flights/to-chicago/' },
                { title: 'Майами', href: 'https://www.wingie.com/ky/flights/to-miami/' },
                { title: 'Канкун', href: 'https://www.wingie.com/ky/flights/to-cancun/' },
                { title: 'Лондон', href: 'https://www.wingie.com/ky/flights/to-london/' },
                { title: 'Гонолулу', href: 'https://www.wingie.com/ky/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                { title: 'Канада', href: 'https://www.wingie.com/ky/flights/ca-canada/' },
                { title: 'Кытай', href: 'https://www.wingie.com/ky/flights/cn-china/' },
                { title: 'Коста-Рика', href: 'https://www.wingie.com/ky/flights/cr-costa-rica/' },
                { title: 'Доминиканская Республика', href: 'https://www.wingie.com/ky/flights/do-dominican-republic/' },
                { title: 'Сальвадор', href: 'https://www.wingie.com/ky/flights/sv-el-salvador/' },
                { title: 'Франция', href: 'https://www.wingie.com/ky/flights/fr-france/' },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/ky/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/ky/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/ky/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/ky/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/ky/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/ky/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-tg': [
        {
            title: 'Самые популярные направления',
            items: [
                { title: 'Лас-Вегас', href: 'https://www.wingie.com/tg/flights/to-las-vegas/' },
                { title: 'Чикаго', href: 'https://www.wingie.com/tg/flights/to-chicago/' },
                { title: 'Майами', href: 'https://www.wingie.com/tg/flights/to-miami/' },
                { title: 'Канкун', href: 'https://www.wingie.com/tg/flights/to-cancun/' },
                { title: 'Лондон', href: 'https://www.wingie.com/tg/flights/to-london/' },
                { title: 'Гонолулу', href: 'https://www.wingie.com/tg/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                { title: 'Канада', href: 'https://www.wingie.com/tg/flights/ca-canada/' },
                { title: 'Чин', href: 'https://www.wingie.com/tg/flights/cn-china/' },
                { title: 'Коста-Рика', href: 'https://www.wingie.com/tg/flights/cr-costa-rica/' },
                { title: 'Ҷумҳурии Доминикан', href: 'https://www.wingie.com/tg/flights/do-dominican-republic/' },
                { title: 'Эл Салвадор', href: 'https://www.wingie.com/tg/flights/sv-el-salvador/' },
                { title: 'Франция', href: 'https://www.wingie.com/tg/flights/fr-france/' },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/tg/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/tg/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/tg/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/tg/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/tg/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/tg/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-kk': [
        {
            title: 'Ең танымал бағыттар',
            items: [
                { title: 'Лас-Вегас', href: 'https://www.wingie.com/kk/flights/to-las-vegas/' },
                { title: 'Чикаго', href: 'https://www.wingie.com/kk/flights/to-chicago/' },
                { title: 'Майами', href: 'https://www.wingie.com/kk/flights/to-miami/' },
                { title: 'Канкун', href: 'https://www.wingie.com/kk/flights/to-cancun/' },
                { title: 'Лондон', href: 'https://www.wingie.com/kk/flights/to-london/' },
                { title: 'Гонолулу', href: 'https://www.wingie.com/kk/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                { title: 'Канада', href: 'https://www.wingie.com/kk/flights/ca-canada/' },
                { title: 'Қытай', href: 'https://www.wingie.com/kk/flights/cn-china/' },
                { title: 'Коста-Рика', href: 'https://www.wingie.com/kk/flights/cr-costa-rica/' },
                { title: 'Доминиканская Республика', href: 'https://www.wingie.com/kk/flights/do-dominican-republic/' },
                { title: 'Сальвадор', href: 'https://www.wingie.com/kk/flights/sv-el-salvador/' },
                { title: 'Франция', href: 'https://www.wingie.com/kk/flights/fr-france/' },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/kk/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/kk/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/kk/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/kk/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/kk/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/kk/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-nl': [
        {
            title: 'Topbestemmingen',
            items: [
                { title: 'Las Vegas', href: 'https://www.wingie.com/nl/flights/to-las-vegas/' },
                { title: 'Chicago', href: 'https://www.wingie.com/nl/flights/to-chicago/' },
                { title: 'Miami', href: 'https://www.wingie.com/nl/flights/to-miami/' },
                { title: 'Cancún', href: 'https://www.wingie.com/nl/flights/to-cancun/' },
                { title: 'Londen', href: 'https://www.wingie.com/nl/flights/to-london/' },
                { title: 'Honolulu', href: 'https://www.wingie.com/nl/flights/to-honolulu/' },
            ],
        },
        {
            title: 'Populaire landen',
            items: [
                { title: 'Canada', href: 'https://www.wingie.com/nl/flights/ca-canada/' },
                { title: 'China', href: 'https://www.wingie.com/nl/flights/cn-china/' },
                { title: 'Costa Rica', href: 'https://www.wingie.com/nl/flights/cr-costa-rica/' },
                { title: 'Dominicaanse Republiek', href: 'https://www.wingie.com/nl/flights/do-dominican-republic/' },
                { title: 'El Salvador', href: 'https://www.wingie.com/nl/flights/sv-el-salvador/' },
                { title: 'Frankrijk', href: 'https://www.wingie.com/nl/flights/fr-france/' },
            ],
        },
        {
            title: 'Populaire luchtvaartmaatschappijen',
            items: [
                { title: 'American Airlines', href: 'https://www.wingie.com/nl/flights/airlines/american-airlines/' },
                { title: 'Delta Air Lines', href: 'https://www.wingie.com/nl/flights/airlines/delta-air-lines/' },
                { title: 'United Airlines', href: 'https://www.wingie.com/nl/flights/airlines/united-airlines/' },
                { title: 'Alaska Airlines', href: 'https://www.wingie.com/nl/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/nl/flights/airlines/jetblue/' },
                { title: 'Hawaiian Airlines', href: 'https://www.wingie.com/nl/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://www.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://www.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://www.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://www.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://www.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://www.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://www.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://www.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://www.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://www.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://www.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://www.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://www.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://www.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://www.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://www.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://www.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://www.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://www.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://www.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://www.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://www.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://www.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://www.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://www.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://www.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://www.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://www.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://www.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://www.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://www.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://www.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://www.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://www.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://www.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://www.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://www.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://www.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://www.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://www.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://www.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://www.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://www.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://www.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://www.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://www.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://www.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://www.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://www.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://www.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://www.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://www.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://www.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://www.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://www.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://www.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://www.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://www.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://www.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://www.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://www.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://www.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://www.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://www.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://www.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://www.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://www.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://www.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://www.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://www.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://www.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://www.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://www.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://www.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://www.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://www.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://www.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://www.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://www.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://www.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://www.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://www.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://www.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://www.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://www.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://www.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://www.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://www.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://www.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://www.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://www.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://www.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://www.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://www.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://www.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://www.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://www.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://www.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://www.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://www.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://www.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://www.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://www.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://www.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://www.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://www.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://www.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://www.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://www.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://www.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://www.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://www.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://www.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://www.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://www.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://www.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://www.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'us-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://www.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://www.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://www.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://www.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://www.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://www.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://www.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://www.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://www.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://www.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://www.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://www.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://www.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://www.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://www.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://www.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://www.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
}
